import React from 'react';
import PropTypes from 'prop-types';

import { ruleType } from 'types';
import GroupListItem from './components/GroupListItem';
import './style.scss';

const RuleGroupInspectContext = ({ rules, groupOrder, onUpdateRules }) => {
  if (rules.length > 0) {
    return (
      <div styleName="group">
        <div styleName="list-block">
          <div styleName="title">GROUP LIST:</div>
          <React.Fragment>
            {rules.map((model, index) => (
              <GroupListItem
                key={model.id}
                model={model}
                groupOrder={groupOrder}
                index={index}
                onUpdateRules={onUpdateRules}
                rules={rules}
              />
            ))}
          </React.Fragment>
        </div>
      </div>
    );
  }
  return (
    <div styleName="no-rules" data-test="no-rules">
      This Group has no rules
    </div>
  );
};

RuleGroupInspectContext.propTypes = {
  rules: PropTypes.arrayOf(ruleType).isRequired,
  groupOrder: PropTypes.number.isRequired,
  onUpdateRules: PropTypes.func,
};

export default RuleGroupInspectContext;
